// src/plugins/i18n.js
import { createI18n } from 'vue-i18n'
import { themeConfig } from '@themeConfig' // или свой источник дефолтной локали

// локальные JSON как базовый слой (необязательно)
const messages = Object.fromEntries(
  Object.entries(import.meta.glob('../locales/*.json', { eager: true }))
    .map(([key, value]) => [key.split('/').pop().replace('.json', ''), value.default])
)

let _i18n = null

export const getI18n = () => {
  if (!_i18n) {
    const savedLocale = typeof window !== 'undefined' ? localStorage.getItem('lang') : null
    _i18n = createI18n({
      legacy: false,
      locale: savedLocale || themeConfig?.app?.i18n?.defaultLocale || 'en',
      fallbackLocale: 'en',
      messages,
    })

  }
  return _i18n
}


export function mergeRemote(locale, payload) {
  const i18n = getI18n()
  i18n.global.mergeLocaleMessage(locale, payload)
}

export function setLocale(locale) {
  const i18n = getI18n()
  i18n.global.locale.value = locale
  if (typeof window !== 'undefined') {
    localStorage.setItem('lang', locale)
  }
}

export default function install(app) {
  app.use(getI18n())
}
